import { makeStyles } from "@material-ui/core"
import { colors } from "@/styles/colors"

const META_FREE_ENTRY_POINT_WINDOW_BANNER_STANDARD_BACKGROUND_COLOR = colors.purple[50]
const META_FREE_ENTRY_POINT_WINDOW_BANNER_STANDARD_BORDER_COLOR = colors.purple[200]
const META_FREE_ENTRY_POINT_WINDOW_BANNER_TEXT_COLOR = colors.purple[700]
const META_FREE_ENTRY_POINT_WINDOW_BANNER_WARNING_BACKGROUND_COLOR = colors.yellow[100]
const META_FREE_ENTRY_POINT_WINDOW_BANNER_WARNING_BORDER_COLOR = colors.yellow[200]
const META_FREE_ENTRY_POINT_WINDOW_BANNER_WARNING_TEXT_COLOR = colors.yellow[900]
const META_FREE_ENTRY_POINT_WINDOW_BANNER_INACTIVE_BACKGROUND_COLOR = colors.gray[50]
const META_FREE_ENTRY_POINT_WINDOW_BANNER_INACTIVE_BORDER_COLOR = colors.gray[200]
const META_FREE_ENTRY_POINT_WINDOW_BANNER_INACTIVE_TEXT_COLOR = colors.gray[700]
const META_FREE_ENTRY_POINT_WINDOW_BANNER_INACTIVE_ICON_COLOR = colors.gray[500]
const META_FREE_ENTRY_POINT_WINDOW_BANNER_INACTIVE_LINK_COLOR = colors.purple[500]

const useStyles = makeStyles(() => ({
	container: {
		borderBottom: `1px solid ${META_FREE_ENTRY_POINT_WINDOW_BANNER_STANDARD_BORDER_COLOR}`,
		backgroundColor: META_FREE_ENTRY_POINT_WINDOW_BANNER_STANDARD_BACKGROUND_COLOR,
		padding: "8px 16px",
		paddingRight: 48,
		minHeight: 40,
		position: "relative"
	},
	containerWarning: {
		borderBottom: `1px solid ${META_FREE_ENTRY_POINT_WINDOW_BANNER_WARNING_BORDER_COLOR}`,
		backgroundColor: META_FREE_ENTRY_POINT_WINDOW_BANNER_WARNING_BACKGROUND_COLOR
	},
	statusMessage: {
		fontSize: 13,
		lineHeight: "20px",
		fontWeight: 400,
		color: META_FREE_ENTRY_POINT_WINDOW_BANNER_TEXT_COLOR
	},
	statusMessageWarning: {
		color: META_FREE_ENTRY_POINT_WINDOW_BANNER_WARNING_TEXT_COLOR
	},
	link: {
		color: META_FREE_ENTRY_POINT_WINDOW_BANNER_TEXT_COLOR,
		fontSize: 13,
		lineHeight: "20px",
		fontWeight: 600,
		textDecoration: "underline",
		cursor: "pointer",
		marginLeft: 8,
		whiteSpace: "nowrap",
		flexShrink: 0
	},
	linkWarning: {
		color: META_FREE_ENTRY_POINT_WINDOW_BANNER_WARNING_TEXT_COLOR
	},
	closeButton: {
		color: META_FREE_ENTRY_POINT_WINDOW_BANNER_TEXT_COLOR,
		padding: 4,
		position: "absolute",
		top: 4,
		right: 4
	},
	closeButtonWarning: {
		color: META_FREE_ENTRY_POINT_WINDOW_BANNER_WARNING_TEXT_COLOR
	},
	icon: {
		color: META_FREE_ENTRY_POINT_WINDOW_BANNER_TEXT_COLOR,
		width: 20,
		height: 20,
		marginRight: 8,
		display: "block"
	},
	iconWarning: {
		color: META_FREE_ENTRY_POINT_WINDOW_BANNER_WARNING_TEXT_COLOR
	},
	containerInactive: {
		borderBottom: `1px solid ${META_FREE_ENTRY_POINT_WINDOW_BANNER_INACTIVE_BORDER_COLOR}`,
		backgroundColor: META_FREE_ENTRY_POINT_WINDOW_BANNER_INACTIVE_BACKGROUND_COLOR
	},
	statusMessageInactive: {
		color: META_FREE_ENTRY_POINT_WINDOW_BANNER_INACTIVE_TEXT_COLOR
	},
	linkInactive: {
		color: META_FREE_ENTRY_POINT_WINDOW_BANNER_INACTIVE_LINK_COLOR
	},
	closeButtonInactive: {
		color: META_FREE_ENTRY_POINT_WINDOW_BANNER_INACTIVE_ICON_COLOR
	},
	iconInactive: {
		color: META_FREE_ENTRY_POINT_WINDOW_BANNER_INACTIVE_ICON_COLOR
	}
}))

export default useStyles
